var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2,0,0,2,0,0)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:inherit;stroke-linecap:round;stroke-linejoin:round;}")), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 17.698,
    r: 2.684
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.835,23.45a4.347,4.347,0,0,0-7.67,0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.79,
    cy: 17.698,
    r: 2.684
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5,23.069a4.548,4.548,0,0,0-7.665.381"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.21,
    cy: 17.698,
    r: 2.684
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.5,23.069a4.548,4.548,0,0,1,7.665.381"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.872,7.363l-5.2,5.2-2.557.511.511-2.556,5.2-5.2a1.442,1.442,0,0,1,2.039,0l.006.006A1.44,1.44,0,0,1,22.872,7.363Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "18.707 2.798 16.137 0.55 3.866 0.55 3.866 12.054"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "6.934 5.918 7.956 6.941 10.001 4.896"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "6.934 11.031 7.956 12.054 10.001 10.008"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.558,
    y1: 6.429,
    x2: 14.092,
    y2: 6.429
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.137,
    y1: 10.008,
    x2: 18.182,
    y2: 12.054
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.134,16a5.936,5.936,0,0,0,4.76,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.924,16a5.937,5.937,0,0,0,4.76,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.714,16a5.938,5.938,0,0,0,4.761,1.7"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeer);
export default __webpack_public_path__ + "static/media/peer.594f41fc.svg";
export { ForwardRef as ReactComponent };